import { useNav } from "@pomle/react-router-paths";
import React, { useCallback } from "react";
import { paths } from "render/routes/paths";
import { InformationLayout } from "render/ui/layout/InformationLayout";
import { PageFrameContent } from "render/ui/layout/PageFrameContent";
import { Button, Typography } from "@cur8/maneki";

const DEFAULT_TITLE = "Error";
const DEFAULT_MESSAGE = "An exception has occurred. Please go back to start.";

interface BailViewProps {
  title?: React.ReactNode;
  message?: React.ReactNode;
}

export function BailView({
  title = DEFAULT_TITLE,
  message = DEFAULT_MESSAGE,
}: BailViewProps) {
  const nav = {
    start: useNav(paths.root),
  };

  const handleRestart = useCallback(() => {
    nav.start.go({});
  }, [nav.start]);

  return (
    <PageFrameContent>
      <InformationLayout
        align="start"
        content={
          <>
            <Typography variant="display-s">{title}</Typography>
            <Typography variant="body-m" color="subtle">
              {message}
            </Typography>
          </>
        }
        buttons={
          <Button variant="secondary" onPress={handleRestart} fillContainer>
            Back
          </Button>
        }
      />
    </PageFrameContent>
  );
}
